import { CountryInformation } from '/react4xp/parts/country-information/country-information'

export default (props) => <CountryInformation {...props} />
